import React from 'react';

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <h1>404 - Not Found</h1>
      <p>This is not the page you are looking for</p>
    </div>
  );
};

export default NotFound;
